import React, { useCallback, useEffect } from 'react';
import { Cross } from '@saleshandy/icons';
import CircularProgressBar from '../../design-system/components/atoms/circular-progressbar';
import { accessibleOnClick } from '../../utils/accessible-on-click';
import { IProps } from './type';
import { getUserRole } from '../../utils/user-details';
import { UserRole } from '../../enums/user-roles';

const OnScreenAsyncProgressBar: React.FC<IProps> = ({
  show,
  percentage,
  textPercentage,
  text,
  completionText,
  ctaText,
  ctaRedirectLink,
  onClose,
  isComplete,
  onCompletion,
  classNameSuffix = '',
  notification,
}) => {
  const handleCtaRedirectLink = useCallback(() => {
    if (ctaRedirectLink) {
      window.open(ctaRedirectLink, '_blank', 'noopener,noreferrer');
    }
  }, [ctaRedirectLink]);

  const userRole = getUserRole() as UserRole;
  const clientRole = [
    UserRole.ClientFullAccess,
    UserRole.ClientRestrictedAccess,
    UserRole.ClientNoAccess,
  ];

  useEffect(() => {
    if (isComplete) {
      onCompletion();
    }
  }, [isComplete]);

  if (!show) {
    return <></>;
  }
  return (
    <div className={`async-progress-bar ${classNameSuffix}`}>
      <div
        className={`async-card-body d-flex ${
          !isComplete ? 'align-items-center' : ''
        }`}
      >
        {!isComplete ? (
          <div className="d-flex align-items-center card-body-container">
            <CircularProgressBar
              percentage={percentage}
              text={textPercentage.toString()}
              pathColor="#059669"
              trailColor="#e5e7eb"
              textColor="#059669"
              width="34px"
              height="34px"
              textFontSize="29px"
              textFontWeight="600"
            />
            <div className="d-flex flex-column align-items-flex-start in-progress">
              <span className="text">{text || ''}</span>
              <span
                className={`view-button ${
                  textPercentage > '0%' ? '' : 'disabled'
                }`}
                {...(textPercentage > '0%'
                  ? accessibleOnClick(handleCtaRedirectLink)
                  : accessibleOnClick(() => {}))}
              >
                {(notification.notificationType === 'ai-column-enrichment' ||
                  notification.notificationType ===
                    'ai-column-enrichment-failed') &&
                clientRole?.includes(userRole)
                  ? ''
                  : ctaText || ''}
              </span>
            </div>
          </div>
        ) : (
          <div
            className={`d-flex flex-column align-items-flex-start card-body-container ${
              isComplete ? 'completed' : ''
            }`}
          >
            <span className="text">{completionText || ''}</span>
            <span
              className="view-button"
              {...accessibleOnClick(handleCtaRedirectLink)}
            >
              {(notification.notificationType === 'ai-column-enrichment' ||
                notification.notificationType ===
                  'ai-column-enrichment-failed') &&
              clientRole?.includes(userRole)
                ? ''
                : ctaText || ''}
            </span>
          </div>
        )}
        <div
          {...accessibleOnClick(onClose)}
          className="d-flex align-items-flex-start"
        >
          <Cross
            className={`async-cross-icon ${
              isComplete
                ? 'async-completed-process'
                : 'async-inprogress-process'
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default OnScreenAsyncProgressBar;
